import { KEYS } from 'app/constants/SceneConstants';
import { FONT_BASE } from '../constants/AppFonts';
import { AddCommasToNumber } from '../utils/Utils';
import SceneBaseTT from './SceneBaseTT';

export default class StageComplete extends SceneBaseTT {
  constructor() {
    super({ key: KEYS.StageComplete, active: false });
  }

  init(config) {
    this._config = config.data;
  }

  create() {
    super.create();
    this.setBackgroundImage('background_purple');
    this.game.hud.setState('STAGE_COMPLETE');
    this.add.image(840, 365, 'graphics', 'overlay_panel_stagecomplete');
    this.add.image(570, 720, 'character_thumbs', 'char_pose_' + this._config.heroid).setOrigin(1);
    this.add.image(840, 125, 'locale_text', 'title_stagecomplete');
    this.add.image(579, 255, 'locale_text', 'label_damage').setOrigin(0, 0.5).setAngle(-8);
    this.add.image(891, 255, 'locale_text', 'label_coins').setOrigin(0, 0.5).setAngle(-8);
    this.add.image(579, 360, 'locale_text', 'label_time').setOrigin(0, 0.5).setAngle(-8);
    this.add.image(891, 360, 'locale_text', 'label_lives').setOrigin(0, 0.5).setAngle(-8);
    this.add.image(696, 460, 'locale_text', 'label_total');
    this._addText(579, 300, AddCommasToNumber(this._config.results.damage)).setAngle(-8);
    this._addText(891, 300, AddCommasToNumber(this._config.results.coins)).setAngle(-8);
    this._addText(579, 405, AddCommasToNumber(this._config.results.time)).setAngle(-8);
    this._addText(891, 405, AddCommasToNumber(this._config.results.lives)).setAngle(-8);
    this.add
      .text(840, 520, AddCommasToNumber(this._config.results.score), {
        fontFamily: FONT_BASE.REGULAR,
        fontSize: 78,
        align: 'center',
        color: '#000000',
      })
      .setOrigin(0.5);
    this.game.hud.events.on('btn_continue', this._config.onComplete, this._config.onCompleteScope);
    this.input.keyboard.on('keydown-SPACE', this._config.onComplete, this._config.onCompleteScope);

    if (this._config.results.isHighScore) {
      this.add.spine(840, 625, 'new_high_score', 'animation', true);
      this.add.image(840, 625, 'locale_text', 'label_highscore');
    }

    // this.game.soundController.playMusic('win');
  }

  shutdown() {
    this.input.keyboard.off('keydown-SPACE', this._config.onComplete, this._config.onCompleteScope);
    this.game.hud.events.off('btn_continue', this._config.onComplete, this._config.onCompleteScope);
    this.game.hud.resumePreviousState();
    this._config = null;
    super.shutdown();
  }

  _addText(x, y, value) {
    return this.add
      .text(x, y, value, {
        fontFamily: FONT_BASE.REGULAR,
        fontSize: 50,
        align: 'left',
        color: '#FF00C0',
      })
      .setOrigin(0, 0.5);
  }
}
